import { OverduePaymentButtonService } from './services/OverduePaymentButtonService';
import type { Init } from './types';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export type OverduePaymentButtonData = MergedDataReturnType<[OverduePaymentButtonService]>;

export type OverduePaymentButtonHandlers = MergedHandlersReturnType<[OverduePaymentButtonService]>;

type TApi = ReturnType<OverduePaymentButtonService['api']>;

export class OverduePaymentButtonManager extends WithApi<TApi> {
  public overduePaymentButtonInit = ({ pageStore, mutations, t }: Init) => {
    const [payOverdueBalance] = mutations;

    const overduePaymentButtonService = new OverduePaymentButtonService(pageStore, payOverdueBalance, t);

    this.initApi({
      ...overduePaymentButtonService.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...overduePaymentButtonService.data(),
      },
      handlers: {
        ...overduePaymentButtonService.handlers(),
      },
    } as const;
  };
}
